import type { ReactNode } from 'react';
import { Box } from '@mantine/core';
import classes from './App.module.css';
import ImpersonationBanner from '@components/impersonation/ImpersonationBanner';
import TrialBanner from '@components/subscription/TrialBanner';
import DashboardHeader from '@components/dashboard-header/DashboardHeader';
import { useTheme } from '@contexts/ThemeContext';
import { useSidebar } from '@contexts/sidebar-context';

type AppMainProps = {
  children: ReactNode;
  /** Forwarded to the header's drawer toggle — see DashboardContent. */
  showMenuButton?: boolean;
  onMenuClick?: () => void;
};

const AppMain = ({ children, showMenuButton, onMenuClick }: AppMainProps) => {
  const { colors: themeColors } = useTheme();
  const { isHeaderVisible } = useSidebar();

  return (
    <Box
      className={classes.main}
      style={{
        backgroundColor: themeColors.background,
        minHeight: '100vh',
        width: '100%',
      }}
    >
      {/* Mounted here rather than per page so the bell is present on every
          dashboard screen. The page padding moved onto the inner box so the
          header can sit flush against the top when the page scrolls.

          Full-viewport pages opt out via setIsHeaderVisible(false) — see the
          sidebar context — rather than starting 48px down to clear a strip
          they have no use for. */}
      {isHeaderVisible && <DashboardHeader showMenuButton={showMenuButton} onMenuClick={onMenuClick} />}
      <Box py="lg" px="xs">
        <ImpersonationBanner />
        <TrialBanner />
        {children}
      </Box>
    </Box>
  );
};

export default AppMain;
